import ListSelector from './ListSelector'
import $ from 'jquery'
import messageResource from '../messageResource'
import {TimeApprovalStatus} from 'constants'

export default function ReportTimeTrackStatusFilter(){}

ReportTimeTrackStatusFilter.prototype.init = function(id, initValue, onChangeCallback){
    this.selector = new ListSelector({
        renderTo: $.find("#" + id)[0],
        menuCls: "ttFilterMenu",
        ctCls : "i"
    });
    const preText = messageResource.getMessage("report.show") + "&nbsp";
    this.selector.addItems([
        {
            text: preText + messageResource.getMessage("report.form.show_both_approved_and_not").toLowerCase(),
            value: TimeApprovalStatus.BOTH
        },
        {
            text: preText + messageResource.getMessage("report.form.show_only_approved").toLowerCase(),
            value: TimeApprovalStatus.APPROVED
        },
        {
            text: preText + messageResource.getMessage("report.form.show_only_not_approved").toLowerCase(),
            value: TimeApprovalStatus.NOT_APPROVED
        }
    ]);

    this.selector.on("change", onChangeCallback );
    this.selector.setActiveItemByValue(initValue, true);
    return this;
};

ReportTimeTrackStatusFilter.prototype.getValue = function(){
    return this.selector.getSelectedItem().value;
};

ReportTimeTrackStatusFilter.prototype.setActiveItemByValue = function( value , suppressChangeEvent) {
    this.selector.setActiveItemByValue(value, suppressChangeEvent);
};


// WEBPACK FOOTER //
// ./web/js/controls/ReportTimeTrackStatusFilter.js